<template>
	<div>
		<v-card flat color="transparent">
			<v-card-text>
				<v-row align="center">
					<v-col cols="12" md="3" lg="3" class="mx-0 px-0">
						<!-- <v-text-field v-model="tableProps.search" label="Buscar un banco" clearable prepend-inner-icon="mdi-magnify" hide-details></v-text-field> -->
                        <alternativeTextField2
                            @onChanged="(v) => {trySearch(v);}" 
                            :valueInput="tableProps.search"
                            :rule="[]"
                            :placeholder="'Buscar'"
                            :label="''"
                            data-cy="search-input"
                            :prependInnerIcon="'mdi-magnify'"
                            class="pick-3 mr-md-1 mr-0"
                        ></alternativeTextField2>
					</v-col>
                    <v-col cols="12" md="3" class="mx-0 px-0">
						<v-row class="" justify="start" no-gutters>
						
							<v-col class="">
                                <AlternativeAutocompleteOne
                                    :label="'Empresa'"
                                    :items="serverItems.companies"
                                    :valueInput="selectedCompany"
                                    :loading="loadingCompanies"
                                    @valueChange="(v) => {selectedCompany = v; selectedOffice = ''; index()}"
                                ></AlternativeAutocompleteOne>
                            </v-col>
						</v-row>
					</v-col>
					<v-spacer></v-spacer>
					<v-col cols="12" md="3" lg="2" class="mx-0 px-0 text-right">
						<iconButton :props="createBtnData" v-permission="'positions.create'" ></iconButton>
					</v-col>
				</v-row>
				<v-row>
					<v-col class="mx-0 px-0">
						<datatable :props="tableProps" @method_handler="method_handler"></datatable>
					</v-col>
				</v-row>
			</v-card-text>
		</v-card>
		<modal :props="modalProps" @modalResponse="method_handler">
			<!-- Buttons -->
			<template slot="cardActions">
				<v-row justify="end">
					<v-col cols="12" md="4">
						<secondaryButton
							:props="cancelModal"
						></secondaryButton>
					</v-col>
					<v-col cols="12" md="4">
						<primaryButton
							:props="acceptModal"
						></primaryButton>
					</v-col>
				</v-row>
			</template> 
		</modal>
	</div>
</template>
<script>
import PageStateManager from '../../../../helpers/PageStateManager'
export default {
    data(){
		return {
            selectedCompany: PageStateManager.getState(this.$router.history.current.path, 'selectedCompany')??'',
            loadingCompanies: false,
			actions: [
				
				{
					name: 'Detalle',
					icon: {
						color: 'secondary',
						icon: 'mdi-information-outline'
					},
					disabled: false,
					type: 'redirect',   //  method, external, redirect
					action: '',
                    permissions: 'positions.show'
				},
				{
					name: 'Editar',
					icon: {
						color: 'secondary',
						icon: 'mdi-pencil-outline'
					},
					disabled: false,
					type: 'redirect',   //  method, external, redirect
					action: '/obras/1/edicion',
                    permissions: 'positions.update'
				},
				{
					name: 'PDF',
					icon: {
						color: 'secondary',
						icon: 'mdi-printer-outline'
					},
					disabled: false,
					type: 'method',   //  method, external, redirect
					action: 'pdf',
                    permissions: 'positions.show',
					loading: false,
				},
				{
					name: 'Borrar',
					icon: {
						color: 'secondary',
						icon: 'mdi-delete-outline'
					},
					disabled: false,
					type: 'method',   //  method, external, redirect
					action: 'deleteItemModal',
                    permissions: 'positions.delete'
				},
			],
			tableProps: {
				headers: [
					{
						text: 'Código',
						align: 'left',
						value: 'id',
						class: 'table-b-border'
					},
					{
						text: 'Nombre',
						align: 'left',
						value: 'name',
						class: 'table-b-border'
					},
					{
						text: 'Empresa',
						align: 'left',
						value: 'company.name',
						class: 'table-b-border'
					},
					// {
					// 	text: 'Área',
					// 	align: 'left',
					// 	value: 'area.name',
					// 	class: 'table-b-border'
					// },
					{
						text: 'Estatus',
						align: 'left',
						value: 'status',
						class: 'table-b-border'
					},
					{
						text: 'Acciones',
						align: 'right',
						sortable: false,
						value: 'actions',
						class: 'table-b-border'
					}
				],
				items: [],
				search: '',
				loading: false
			},
            serverItems: {
                companies: [],
            },
			modalProps: {
				visible: false,
				width: '500',
				title: 'Eliminar',
				text: '¿Estás seguro de eliminar?',
				loading: false,
				bottomLineColor: 'error',
				
			},
			
			cancelModal: {
                text: "No, regresar",
                icon: "",
				to: "",
				block: true,
				color: '',
                click: ()=>{this.modalProps.visible = false}
            },
			acceptModal: {
                text: "SI, ELIMINAR",
                icon: "",
				to: "",
				block: true,
				color: 'error',
				textColor:'white',
				loading:false,
                click: ()=>{this.delete()}
            },
			createBtnData: {
				hasTooltip:true,
                tooltip: 'Nuevo puesto',
                color:'primary',
                height:'35',
				text: "",
				icon: "mdi-plus",
				to: "PositionsCreate",
				block: true,
				click: ()=>{}
			},
			
		}
	},

	mounted(){
		this.getCompanies()
	},
    watch: {
        /**
         * Reset values on "type" change
         */
        [`selectedCompany`]: function () {
            console.log(this.$router.history.current.path)
            PageStateManager.setState(this.$router.history.current.path, 'selectedCompany', this.selectedCompany)
        },
        
        
        // prevHeight: function(v){
        //     if(v != 0)
        //         this.prevHeight = 0;
        // }
    },

  methods: {
    method_handler(object){
      this[object.method_name](object.parameters)
    },
    trySearch(val){
        this.tableProps.search = val;
    },
    index() {
      this.tableProps.loading = true;

      //call api
      this.$api.positions.index(this.selectedCompany)
        .then((resp) =>{
				
			//console.log(resp, "desde locations");
			this.tableProps.items = resp.data.map((x,i) => {
				x['actions'] = JSON.parse(JSON.stringify(this.actions))
				x.actions[0].action = { name: 'PositionsDetails', params: { id: x.id } }
				x.actions[1].action = { name: 'PositionsEdit', params: { id: x.id } }

				
				
			
				x['parameters'] = { id: x.id, name: x.name, index:i};
				x.status = 'Activo';
				// x.status = x.status == true ? 'Activo' : 'Inactivo';
				return x
			});

		})
        .catch((error) =>{
          console.log(error, "error desde positions");
        })
        .finally(() => {
          this.tableProps.loading = false;
        })
      ;
      //console.log(test);
      
      
      
    },

	deleteItemModal(parameters)
	{
		//console.log(parameters);
		this.selectedID = parameters.id;
		this.modalProps = {
			...this.modalProps,
			text: `¿Estás seguro de eliminar "${parameters.name}"?`,
			
		}
		this.modalProps.visible = true;
		
	},


	delete()
	{
		//console.log(this.selectedID);
		this.acceptModal.loading = true;
		this.$api.positions.delete(this.selectedID)
		// eslint-disable-next-line
		.then((response) => {
			
			this.$store.dispatch('snackbarSuccess', `Se eliminó el puesto`);
			this.index()
			// eslint-disable-next-line
		}).catch(error => {
			

			this.$store.dispatch('snackbarError', `Error al eliminar. Intenta de nuevo`);
		})
		.finally(() => {
			this.modalProps.visible = false;
			this.acceptModal.loading = false;
		})
	},

    getCompanies()
    {
        this.loadingCompanies = true;
        this.$api.user.getUserBusinessSelect()
            .then((resp) =>{
                
               this.serverItems.companies.push({value:"TODAS", text: "TODAS"});
                resp.data.map((comp) => {
                    this.serverItems.companies.push( {text: comp.name, value: comp.id})
                });

                if(this.serverItems.companies.length >= 1){
                    if(this.selectedCompany == "")
                        this.selectedCompany = this.serverItems.companies[0].value;
                    this.index();
                    
                }
                
            })
            .catch((error) =>{
                console.log(error, "error getBusinessSelect");
            })
            .finally(() => {
                this.loadingCompanies = false;
            })
        ;
    },

	pdf(parameters)
	{
		console.log(this.tableProps.items[parameters.index])
		this.tableProps.items[parameters.index].actions[2].loading = true;
		// this.$store.state.loading = true;
		this.$api.positions.pdf(parameters.id)
			.then((resp) => {
				const fileURL = window.URL.createObjectURL(new Blob([resp.data]));
				const fileLink = document.createElement("a");
				fileLink.href = fileURL;
				fileLink.setAttribute(
				"download",
				`${parameters.name}.pdf`
				);
				document.body.appendChild(fileLink);
				fileLink.click();
			})
			.catch((error) => {
				console.log(error);
				if(this.tableProps.items[parameters.index].company == null){
					this.$store.dispatch('snackbarError', `La empresa no es válida.`);
				}else{
					this.$store.dispatch('snackbarError', `Error al descargar`);
				}
			})
			.finally(() => {
				this.tableProps.items[parameters.index].actions[2].loading = false;
				// this.$store.state.loading = false;
			})
		;
	},

  }
}
</script>